export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7489.39c5f888.jpg";